import type {
  CommonRequestFn,
  CommonRequestFnWithoutPayload
} from "@marketplace/http";
import type { BaseResponse } from "@marketplace/shared/types";

import { ENDPOINTS } from "@/constants/endpoints";
import { httpClient } from "@/http";

import type { GetProfileDataResponseDto } from "../dtos/get-profile-data-response-dto";
import type { SendOtpWithoutAuthRequestDto } from "../dtos/send-otp-without-auth-request-dto";

type ProfileServiceContract = {
  getProfileData: CommonRequestFnWithoutPayload<GetProfileDataResponseDto>;
  sendOtpWithoutAuth: CommonRequestFn<
    SendOtpWithoutAuthRequestDto,
    BaseResponse<null>
  >;
};

export const ProfileService: ProfileServiceContract = {
  getProfileData: async () => {
    return await httpClient
      .get(ENDPOINTS.PROFILE.USER_DATA)
      .json<GetProfileDataResponseDto>();
  },
  sendOtpWithoutAuth: async ({ payload, options }) => {
    return await httpClient
      .post(ENDPOINTS.PROFILE.SEND_OTP_WITHOUT_AUTH, {
        ...options,
        json: payload
      })
      .json<BaseResponse<null>>();
  }
};
